export default __webpack_public_path__ + "static/media/down_icons.f62ac506.svg";